
import React, { useState } from 'react';
import { Navigate } from "react-router-dom";
import {
  Tooltip,
} from "@mui/material";

import {
  Background,
  Condition,
  Creature,
  DandDFeatureSource,
  EldritchInvocation,
  Feat,
  FightingStyle,
  GameClass,
  Gift,
  // MagicItem,
  MagicItemKeyword,
  OrgPosition,
  PactBoon,
  Race,
  Subclass,
  Subrace
} from "@dndModels";

import API from "@dndUtilities/system_api";

import CopyButton from "@components/input/buttons/CopyButton";
import { DataType, isDataType } from '@dndModels/Types';
import { ModelBase } from '@models';

interface Props {
  copyMe: DandDFeatureSource | Creature;
  special_copy_type: DataType | "";
  processing: boolean;
  setProcessing: (changed: boolean) => void;
}

export default function CopyToFeatureSource({
  copyMe,
  special_copy_type,
  processing,
  setProcessing
}: Props) {
  const [navigateTo, setNavigateTo] = useState<string | null>(null);

  const api = API.getInstance();

  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Tooltip title={`Copy ${copyMe.name} to Selected Type`}>
        <span>
          <CopyButton
            label={`Selected Type`}
            disabled={
              special_copy_type === "" ||
              processing ||
              // disabled ||
              // view_only || 
              api.user === null ||
              !(api.user.admin ||
                copyMe.owner_id === api.user._id
              )
            }
            onClick={ async () => {
              if (isDataType(special_copy_type)) {
                setProcessing(true);
                // onProcessingChange(false);
                const user = api.user;
                if (user) {
                  let new_obj = new DandDFeatureSource();
                  switch (special_copy_type) {
                    case "background":
                      new_obj = new Background();
                    break;
                    case "condition":
                      new_obj = new Condition();
                    break;
                    case "eldritch_invocation":
                      new_obj = new EldritchInvocation();
                    break;
                    case "feat":
                      new_obj = new Feat();
                    break;
                    case "fighting_style":
                      new_obj = new FightingStyle();
                    break;
                    case "game_class":
                      new_obj = new GameClass();
                    break;
                    case "gift":
                      new_obj = new Gift();
                    break;
                    case "pact_boon":
                      new_obj = new PactBoon();
                    break;
                    case "race":
                      new_obj = new Race();
                    break;
                    case "subclass":
                      new_obj = new Subclass();
                    break;
                    case "subrace":
                      new_obj = new Subrace();
                    break;
                    // case "magic_item":
                    //   new_obj = new MagicItem();
                    // break;
                    case "magic_item_keyword":
                      new_obj = new MagicItemKeyword();
                    break;
                    case "org_position":
                      new_obj = new OrgPosition();
                    break;
                  }
                  new_obj.specialCopy(copyMe);
                  if (!user.admin) {
                    new_obj.owner_id = user._id;
                    new_obj.source_books_old = [{ type: "Homebrew", id: user._id, third_party: false }];
                  }
                  if (api.user && api.user.admin) {
                    api.applyWorkingOn(new_obj);
                  }
                  debugger; // I've been having problems where it doesn't get added to the smart hash appropriately, 
                  // which makes it so when you get to the page for it, everything is blank, 
                  // and if you go to the index it's not there. You have to refresh to get it there.
                  // Haven't figured out why yet, but low priority.
                  const res = await api.upsertObject(special_copy_type, new_obj);
                  if (res && res.res instanceof ModelBase) {
                    const changed = res.res;
                    api.handleVersion(changed, changed.data_type);
                  }
                  setProcessing(false);
                  // onProcessingChange(false);
                  if (res) {
                    setNavigateTo(`/${special_copy_type}/${res.body.id}`);
                  }
                }
              }
            }}
          />
        </span>
      </Tooltip>
    );
  }
}
